import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import CostiRankingTableSet from "./CostiRanking.TableSet";
import CostiAnalisiKPISet from "../costiAnalisi/CostiAnalisi.KPISet";
import JSONPretty from 'react-json-pretty'

const CostiRanking = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showCostiRanking = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Costs')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <CostiAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showCostiRanking &&
                <CostiRankingTableSet dataProviderName={dataProviderName} filters={filters} />
            }
        </Box>
    )
}

export default CostiRanking;
